import { Box, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React from 'react'


function ComboMultiChefitList(props: any) {
  return (
    <Box>
        <Typography fontWeight={600} fontSize={'1.5vw'} mb={'1vw'}>Multi Chefit List</Typography>
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align={'left'}>S.No</TableCell>
                        <TableCell align={'left'}>Multi Day Chefit Id</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props?.multiChefitData?.length > 0 && props?.multiChefitData?.map((multiChefit: any, index: number) => (
                        <TableRow key={index}>
                            <TableCell>{index+1}</TableCell>
                            <TableCell>
                            <Link href={`/#/MultiDayChefit/${multiChefit}/show`}>
                                {multiChefit}
                            </Link>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </Box>
  )
}

export default ComboMultiChefitList
